// Match times may arrive from the database as HH:mm:ss or from a time input as HH:mm.
export function defaultMatchWarmupTime(matchTime: string | null | undefined, minutesBefore: number): string {
  if (!matchTime || !Number.isFinite(minutesBefore)) return '';
  const [hours, minutes] = matchTime.slice(0, 5).split(':').map(Number);
  if (!Number.isInteger(hours) || !Number.isInteger(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return '';
  const total = ((hours * 60 + minutes - minutesBefore) % 1440 + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}

export function warmupFollowsTeamDefault(
  matchTime: string | null | undefined,
  warmupTime: string | null | undefined,
  minutesBefore: number,
): boolean {
  if (!warmupTime) return true;
  const expected = defaultMatchWarmupTime(matchTime, minutesBefore);
  return Boolean(expected) && warmupTime.slice(0, 5) === expected;
}
